if (!customElements.get('sidiz-article-content')) {
  customElements.define('sidiz-article-content', class extends HTMLElement {
    connectedCallback() {
      this.scrollers = [];
      const tables = Array.from(this.querySelectorAll('table')).filter(
        (table) => !table.parentElement.closest('table')
      );

      tables.forEach((table, index) => {
        let scroller = table.parentElement;
        if (!scroller.classList.contains('sidiz-article-table-scroll')) {
          scroller = document.createElement('div');
          scroller.className = 'sidiz-article-table-scroll';
          table.before(scroller);
          scroller.appendChild(table);
        }
        const columns = Math.max(1, ...Array.from(table.rows, (row) =>
          Array.from(row.cells).reduce((count, cell) => count + cell.colSpan, 0)
        ));
        const minimumWidth = columns === 1 ? 0 : columns === 2 ? 480 : columns === 3 ? 640 : Math.min(960, columns * 180);
        scroller.dataset.columnCount = String(columns);
        scroller.style.setProperty('--sidiz-article-table-min-width', `${minimumWidth}px`);
        const caption = table.caption?.textContent.trim();
        const label = caption || table.getAttribute('aria-label') || `${this.dataset.tableLabel || 'Article table'} ${index + 1}`;
        this.scrollers.push({ element: scroller, table, label });
      });

      // Keep the no-JavaScript scroll fallback, but focus each wide table separately.
      this.removeAttribute('tabindex');
      this.removeAttribute('role');
      this.removeAttribute('aria-label');
      this.updateOverflow = () => {
        this.scrollers.forEach(({ element, label }) => {
          if (element.scrollWidth > element.clientWidth + 1) {
            element.setAttribute('tabindex', '0');
            element.setAttribute('role', 'region');
            element.setAttribute('aria-label', label);
          } else {
            element.removeAttribute('tabindex');
            element.removeAttribute('role');
            element.removeAttribute('aria-label');
          }
        });
      };

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateOverflow);
        this.scrollers.forEach(({ element, table }) => {
          this.resizeObserver.observe(element);
          this.resizeObserver.observe(table);
        });
      } else {
        window.addEventListener('resize', this.updateOverflow);
      }
      this.updateOverflow();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.updateOverflow);
    }
  });
}
